import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { userForgetPassword } from "../../store/actions";

// import images
import profile from "../../assets/images/logo-light.png";
import logo from "../../assets/images/logo.svg";
import UserService from "Api/Services/UserService";
import Spinners from "components/Common/Spinner";

const ForgetPasswordPage = props => {

  //meta title
  document.title = "Forget Password | infuseone";
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [isLoading, setLoading] = useState(false);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setError('Email is required');
      return;
    }
    const userData = {
      email: email,
    };
    setLoading(true);
    try {
      const response = await UserService.forgot_pwd(userData).json();

      if (response.status === true) {
        // setTimeout(() => {
        setError('');
        setSuccess(response.message);
        setLoading(false);
        // }, 500);
      } else {
        setError(response.message);
        return;
      }
    } catch (error) {
      setError('something went wrong');
      return;
    }
  };
  // useEffect(() => {
  //   setError('');
  // }, []);



  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          {isLoading ? <Spinners setLoading={setLoading} /> :
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="overflow-hidden commonboxform">
                  <div className="bg-primary-subtle">
                    <Row>
                      <Col xs={7}>
                        <div className="text-primary p-4">
                          <h5 className="text-primary">Forget Password</h5>
                          <p>Need to reset your password?</p>
                        </div>
                      </Col>
                      <Col className="col-5 align-self-end">
                        <img src={profile} alt="" className="img-fluid" />
                      </Col>
                    </Row>
                  </div>
                  <CardBody className="pt-0">
                    {/* <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div> */}
                    <div className="p-2">
                      {success && (
                        <Alert color="success" style={{ marginTop: "13px" }}>
                          {success}
                        </Alert>
                      )}


                      <Form onSubmit={handleSubmit}
                        className="form-horizontal"
                      >
                        <div className="mb-3">
                          <Label className="form-label">Email <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                          <Input
                            name="email"
                            className="form-control"
                            placeholder="Enter email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                          {error && (
                            <FormFeedback type="invalid" style={{ display: "block" }}>{error}</FormFeedback>
                          )}
                        </div>
                        <Row className="mb-0">
                          <Col className="text-center">
                            <button 
                              className="btn btn-secondary btn-block w-100"
                              type="submit"
                            >
                              Reset
                            </button>
                          </Col>
                          <div className="mt-4 text-center">
                            <p>
                              Go back to{" "}
                              <Link to="/" className="font-weight-medium text-primary">
                                Login
                              </Link>{" "}
                            </p>
                          </div>
                        </Row>
                      </Form>
                    </div>
                  </CardBody>
                </Card>

              </Col>
            </Row>
          }
        </Container>
      </div>
    </React.Fragment>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
